// extracted by mini-css-extract-plugin
export default {"policy-holders-page-title":"styles_policy-holders-page-title__MeZw8","details-loading":"styles_details-loading__yVXfg","shimmer":"styles_shimmer__NcKOu"};